import styled from 'styled-components';

export const PageContainer = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
    
    @media (max-width: 768px) {
        padding: 0 24px;
        box-sizing: border-box;
    }
`;

export const Section = styled.section`
    padding: 100px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    
    h2 {
        font-size: 2rem;
        margin-bottom: 24px;
        color: #333;
        width: 100%;
    }

    p {
        font-size: 1.1rem;
        color: #666;
        max-width: 800px;
        margin: 0 auto 32px;
        width: 100%;
        line-height: 1.6;
    }

    @media (max-width: 768px) {
        padding: 80px 0;
        text-align: center;
        gap: 20px;
    }
`;
